import React from "react";

interface RadarWidgetProps {
  className?: string;
}

const RadarWidget: React.FC<RadarWidgetProps> = ({ className }) => {
  return (
    <div className={`lg:flex-[55] flex-1 flex flex-col ${className || ""}`}>
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-white">Carte radar</h2>
        <a
          href="#"
          className="flex items-center gap-2 rounded border border-white px-3 py-1 text-sm text-white hover:bg-white hover:text-nearblack-500"
        >
          <span>Voir cartes</span>
          <i className="fas fa-arrow-right"></i>
        </a>
      </div>
      <a href="#" className="block flex-1 overflow-hidden rounded-lg">
        <div className="relative h-full min-h-[250px] bg-meteoblue-500/30">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <i className="fas fa-map-marked-alt text-5xl text-white/50"></i>
              <p className="mt-2 text-sm text-white/70">
                Carte radar indisponible
              </p>
              <p className="text-xs text-white/50">(On a perdu le satellite)</p>
            </div>
          </div>
          <div className="absolute bottom-2 left-2 text-xs text-white/70">
            <p>Montréal</p>
            <p>Laval</p>
            <p>Saint-Jérôme</p>
          </div>
          <div className="absolute bottom-2 right-2 text-xs text-white/70">
            <p>Granby</p>
            <p>Saint-Hyacinthe</p>
          </div>
        </div>
      </a>
    </div>
  );
};

export default RadarWidget;
